<app-tabs-list [activeTab]="activeTab | async" [tabs]="tabs | async" (onSelect)="onSelect($event)" (onRemove)="onRemove($event)">
</app-tabs-list>
